<p-sidebar
  [(visible)]="show"
  styleClass="sidebar_dtic"
  data-parent="#accordionSidebar"
>
  {{ "menus.titulo" | translate }}

  <div class="margin-top">
    <ng-container *ngFor="let menu of menus; let ult = last">
      <ng-container *ngIf="menu.items.length == 0">
        <!-- MENUS -->
        <div class="menu-item" (click)="goMenuItem(menu, null)">
          <table style="width: 100%">
            <tr>
              <td style="width: 24px">
                <img
                  width="24"
                  style="vertical-align: middle"
                  [src]="menu.icono"
                  (error)="$event.target.src = config.SISTEMA.URL.PATH404IMG"
                  *ngIf="config.SISTEMA.MENUS.FLAT_ICONS"
                />
                <i
                  class="{{ menu.icono }} {{
                    menu.id == menu_selected?.id ? 'text-primary' : ''
                  }}"
                  *ngIf="!config.SISTEMA.MENUS.FLAT_ICONS"
                ></i>
              </td>
              <td>
                <span
                  class=" menu-item-text {{
                    menu.id == menu_selected?.id ? 'text-primary active' : ''
                  }}"
                  >{{ menu.nombre }}</span
                >
              </td>
            </tr>
          </table>
        </div>
      </ng-container>
      <ng-container *ngIf="menu.items.length > 0">
        <!-- ITEMS -->
        <div
          class="menu-item item-item collapsed"
          href="#"
          data-toggle="collapse"
          [attr.data-target]="'#menu_' + menu.id"
          aria-expanded="true"
          [attr.data-labelledby]="'#menu_' + menu.id"
        >
          <table style="width: 100%">
            <tr>
              <td style="width: 24px">
                <img
                  width="24"
                  style="vertical-align: middle"
                  [src]="menu.icono"
                  (error)="$event.target.src = config.SISTEMA.URL.PATH404IMG"
                />
                <i
                  class="{{ menu.icono }} {{
                    menu.id == menu_selected?.id ? 'text-primary' : ''
                  }}"
                  *ngIf="!config.SISTEMA.MENUS.FLAT_ICONS"
                ></i>
              </td>
              <td class="menu_name">
                <span
                  class=" menu-item-text {{
                    menu.id == menu_selected?.id ? 'text-primary active' : ''
                  }}"
                  >{{ menu.nombre }}</span
                >
              </td>
            </tr>
          </table>
        </div>
        <div id="menu_{{ menu.id }}" class="collapse">
          <div class="box_items">
            <ng-container *ngFor="let item of menu.items">
              <div class="menu-item" (click)="goMenuItem(menu, item)">
                <table style="width: 100%">
                  <tr>
                    <td
                      style="width: 24px"
                      *ngIf="config.SISTEMA.MENUS.ITEMS_ICON"
                    >
                      <img
                        width="24"
                        style="vertical-align: middle"
                        [src]="item.icono"
                        (error)="
                          $event.target.src = config.SISTEMA.URL.PATH404IMG
                        "
                      />
                      <i
                        class="{{ item.icono }} {{
                          item.metodo == item_selected?.metodo
                            ? 'text-primary'
                            : ''
                        }}"
                        *ngIf="!config.SISTEMA.MENUS.FLAT_ICONS"
                      ></i>
                    </td>
                    <td>
                      <span
                        class=" menu-item-text {{
                          item.metodo == item_selected?.metodo
                            ? 'text-primary active'
                            : ''
                        }}"
                        >{{ item.nombre }}</span
                      >
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</p-sidebar>
